<template>
    <div>
        <a-form 
            ref="uploadRef"
            class="upload"
            layout="horizontal"
            label-align="right"
            :label-col-props="{ span: 8 }"
            :wrapper-col-props="{ span: 14 }"
        >
            <a-form-item 
                :label="$t('base.uploadImg')" 
                label-col-style="150px"
            >
                <slot name="desc"></slot>
                <a-upload 
                    style="display:block;"
                    v-model="fileList"
                    accept=".jpg,.jpeg"
                    :headers="headers"
                    :action="action"
                    :limit="limit"
                    list-type="picture-card" 
                    image-preview
                    :on-before-upload="onBeforeUpload"
                    @change="changeUpload"
                    @success="successUpload"
                    @error="errorUpload"
                />
            </a-form-item>
        </a-form>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { Message, Modal } from '@arco-design/web-vue';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n()
    
    const fileList = ref([])
    const action = ref(import.meta.env.VITE_BASE_URL + '/order/module/upload')
    const headers = ref({
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
    })
    // const accept = '.jpg,.jpeg,.png,.webp,.bmp,.tif,.gif'
    const limit = ref(3) // 上传图片最大数量
    const maxSize = ref(5 * 1024 * 1024) // 单张图片大小

    const emit = defineEmits(['changeUpload','successUpload','errorUpload','onBeforeUpload'])

    const onBeforeUpload = (file)=>{
        // console.log(file,'file')
        emit('onBeforeUpload',file)

        let imgType = ['jpg','jpeg']
        let type = file.type.split('/')[1]
        // console.log(type, !imgType.includes(type),'type')
        if(file.size > maxSize.value){
            Message.error(t('returnExchange.imgLimit'))
            return false
        }
        if(!imgType.includes(type)){
            Message.error(t('returnExchange.imgLimit2'))
            return false
        }
        return true
    }

    const changeUpload = (fileList,fileItem)=>{
        emit('changeUpload',fileList,fileItem)
    }

    const successUpload = (fileItem)=>{
        // console.log(fileItem,'成功')
        emit('successUpload',fileItem)
    }

    const errorUpload = (fileItem)=>{
        // console.log(fileItem,'fileItem222')
        emit('errorUpload',fileItem)
    }

    defineExpose({
        fileList,
    })
</script>

<style lang="less" scoped>
.upload{
    min-width: 70%;
    max-width:85%;
    margin:-90px auto 0;
    padding:20px;
}
</style>